Namespace 'Customer.Ticket'

class Customer.Ticket.TicketsByUserModal extends Backbone.View
  template: JST['backbone/templates/customer/ticket/tickets_by_user_modal']

  events:
    'click .tickets-by-user-modal-close': 'onClose'

  initialize: ({extendedUserProfile, periodToCheck}) ->
    @extendedUserProfile = extendedUserProfile
    @periodToCheck = periodToCheck
    @externalTicketViews = []

  fetchExternalTickets: ->
    externalTickets = new Customer.Ticket.SkyChile.ExternalTicketCollection @extendedUserProfile.getExternalTickets()
    externalTickets.fetchAssociatedCEMTickets()
    externalTickets.each @_addExternalTicketView
    @listenTo(Backbone, 'ui:blocked', @onCloseWhenTicketOpened)

  _addExternalTicketView: (externalTicket) =>
    @externalTicketViews.push new Customer.Ticket.SkyChile.ExternalTicketView(externalTicket: externalTicket)

  show: ->
    @$el.html @template
      images: @_images()
    $elementBody = @$('.tickets-by-user-body')
    @externalTicketViews.forEach (ticketView) -> $elementBody.append ticketView.render().$el
    @$('.tickets-by-user-modal').modal()

  onClose: ->
    @_hideModal()

  onCloseWhenTicketOpened: ->
    @_hideModal()
    Backbone.trigger 'ui:unblocked'

  _hideModal: ->
    @$('.tickets-by-user-modal').modal 'hide'

  render: ->
    @

  _images: ->
    [
      window.image_path('close_modal_cross/close_modal_cross.png'),
      window.image_path('close_modal_cross/close_modal_cross@2x.png'),
      window.image_path('close_modal_cross/close_modal_cross@3x.png'),
    ]
